module.exports = __webpack_public_path__ + "img/IMG_8904.70095355.jpg";